import React, {Fragment, useEffect, useRef, useState} from "react";
import { Transition } from '@headlessui/react'
import './global-notification.styles.scss'

const windowGlobal = typeof window !== 'undefined' && window

const GlobalNotification = ({children})=>{
    const sessionState = windowGlobal?.sessionStorage?.getItem("global-notification-show");
    let stateInit;
    if(sessionState) {
        stateInit = (sessionState === 'true');
    } else {
        windowGlobal?.sessionStorage?.setItem('global-notification-show', 'true')
        stateInit = true;
    }
    const [open, setOpen] = useState(stateInit);
    let body;

    useEffect(()=>{
        body = document.getElementById("gatsby-focus-wrapper");
        body?.classList.add("with-notification");
    })
    return(
        <>
            <Transition
                show={open}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-y-full opacity-0"
                enterTo="translate-y-0 opacity-100"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="absolute translate-y-0 opacity-100"
                leaveTo="-translate-y-full opacity-0 absolute"
                as={Fragment}
            >
                <div className="global-notification bg-secondary text-white flex flex-row justify-self-start items-center">
                    <div className="container flex flex-row justify-between items-center">
                        <div className="text-center flex-auto">
                            {children}
                        </div>
                    </div>
                </div>
            </Transition>
        </>

    )



}


export default  GlobalNotification;
